import * as React from 'react'

import type { IconName } from './iconMeta'
import type { GlyphData } from './icons'

import styles from './IconPicker.module.css'

type IconGlyphProps = {
  icon: IconName
  glyph: GlyphData | undefined
  /** Rendered pixel size. */
  size: number
}

/**
 * Renders a curated glyph's raw SVG geometry. The `<svg>` fills with
 * `currentColor`, so the glyph inherits the tint set on its container.
 *
 * @internal Shared by `IconPicker` and `IconTile`; not part of the public API.
 */
export const IconGlyph = ({
  icon,
  glyph,
  size,
}: IconGlyphProps): React.JSX.Element | null => {
  if (!glyph) return null
  return (
    <svg
      className={styles.glyph}
      data-icon={icon}
      width={size}
      height={size}
      viewBox={glyph.viewBox}
      fill="currentColor"
      aria-hidden
      focusable={false}
    >
      {glyph.paths}
    </svg>
  )
}
